import React from 'react';
import './toast.scss';

const ErrorToast = ({ header = 'Error', body }) => {
    return (
        <div className='base-toast-div'>
            <i className="bi bi-x-circle custom-toast-error-icon"></i>
            <div style={{ marginLeft: '10px' }}>
                <div className='base-toast-header'>
                    <div>
                        <h6 className='custom-toast-title-error'>{header}</h6>
                    </div>
                </div>
                <div className='custom-toast-body-message'>
                    <span>{body}</span>
                </div>
            </div>
        </div>
    );
};

export default ErrorToast;
